import { MultiSelect } from "primereact/multiselect";

import { Container } from "./MultiSelectStyledStyles";

function MultiSelectStyled(props) {
  const { info, onInfoChange, selectItems, width, height } = props;
  return (
    <Container width={width} height={height}>
      <MultiSelect
        display="chip"
        value={info}
        options={selectItems}
        onChange={onInfoChange}
      />
    </Container>
  );
}

export default MultiSelectStyled;
